export class CustomerRoiToolFilter {
    public IncludeInactive?: boolean;
    public CRTNumber?: string;
}

export default CustomerRoiToolFilter;